import APIController from "./APIController"
const Workspace = () => {
    //Requesthelper
    const { basicRequest, jsonRequest, getWorkspaceId } = APIController()

    const createWorkspace = async(workspaceDTO) =>{
        const data = await basicRequest("/workspace/new", "POST", workspaceDTO)
        return data
    }

    const fetchUserFromWorkspace = async() =>{
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await jsonRequest(`/${workspaceId}/workspace/user`)
        return data
    }

    const addUserPerCode = async(userEmailDTO) =>{
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await basicRequest(`/${workspaceId}/workspace/add`, "POST", userEmailDTO)
        return data
    } 

    const removeUser = async(id)=>{
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await basicRequest(`/${workspaceId}/workspace/remove/${id}`, "DELETE")
        return data
    }

    const updateWorkspace = async(workspaceDTO) =>{
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await basicRequest(`/${workspaceId}/workspace/update`, "PUT", workspaceDTO)
        return data
    }

    const deleteWorkspace = async() =>{
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await basicRequest(`/${workspaceId}/workspace/deactivate`, "DELETE")
        return data
    }

    const employeePermission = async(id)=>{
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await basicRequest(`/${workspaceId}/workspace/employee_permission/${id}`, "PUT")
        return data
    }

    const managerPermission = async(id)=>{
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await basicRequest(`/${workspaceId}/workspace/manager_permission/${id}`, "PUT")
        return data
    }

    const editUserPasscode = async(id, dto)=>{
        const workspaceId = await getWorkspaceId()
        if (!workspaceId) return null;
        const data = await basicRequest(`/${workspaceId}/workspace/update_user_code/${id}`, "PUT", dto)
        return data
    }

    return{
        createWorkspace,
        fetchUserFromWorkspace,
        addUserPerCode,
        removeUser,
        updateWorkspace,
        deleteWorkspace,
        employeePermission,
        managerPermission,
        editUserPasscode
    }
}
export default Workspace